import React, {Component} from 'react';
//import * as routes from '../../constants/routes'
import DefaultPage from '../../../../Container/Layout/DefaultPage'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { doAddEvent, fetchTasks } from '../../../../firebase/db'
import * as routes from '../../../../constants/routes'
import InAppNav from '../../../InAppNav/InAppNav'
//import AddEventInfo from './AddEventInfo'
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import {compose} from 'recompose'
import moment from 'moment'
import Checkbox from '@material-ui/core/Checkbox'
//import Typography from '@material-ui/core/Typography';
import Input from '@material-ui/core/Input';
//import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { getImpUsers, setImpUser } from '../../../../firebase/database/handleUserMgm'

import 'react-select/dist/react-select.css'
//import 'react-select/dist/styles.js'
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'
// Then import the virtualized Select HOC
import VirtualizedSelect from 'react-virtualized-select'
import arraySort from 'array-sort'

const styles = theme => ({
  paper: {
    display: 'inline-block',
    padding: '1em',
    marginBottom: '1em',
    marginRight: '1em'
  },
  textField: {
    marginBottom: theme.spacing.unit *2,
   //marginRight: theme.spacing.unit,
    
  },
  requesterSelect: {
      width: '100%',
      marginBottom: theme.spacing.unit *2
  },
  'Select-menu-outer': {
    color: 'black',
    backgroundColor: 'red'
  },
  requesterDetails: {
    display: 'inline-block',
    width: '40%',
    padding: theme.spacing.unit *2

  }
});

const byPropKey = (propertyName, value) => () => {
return ({
    [propertyName]: value,
  });

}

const preDate = moment().add(1, 'days').format('YYYY-MM-DD');

class AdminAddEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTask: '',
      selectedTaskId: '',
      info: '',
      timeStamp: '',
      date: preDate,
      timeRange: '',
      pkwChecked: '',
      onTime: false,
      onTimeChecked: false,
      time:'',
      selectedRequester: ''
    };
    this.dateInputRef = React.createRef()

   // this.requesterSelect = React.createRef()
  }

  handleFormChange = (propKey, value) => {
 
    if(propKey==='timeRange') {
      switch (value) {
        case '1week' : {
          
          this.setState({
            timeRange: '2weeks',
            date: moment().add(7, 'days').format('YYYY-MM-DD'),
            onTime: false,
            time: 'nv',
            onTimeChecked: false,
          })
          break
        }
        case '2weeks' : {
          this.setState({
            timeRange: '2weeks',
            date: moment().add(14, 'days').format('YYYY-MM-DD'),
            onTime: false,
            time: 'nv',
            onTimeChecked: false,
          })
          break
        }
        case 'onDate' : {
          this.setState({
              timeRange: 'onDate',
              date: moment().add(1, 'days').format('YYYY-MM-DD'),
              onTime: true,
            })
          break
        } 
        default : this.setState({
            timeRange: 'notSet',
            date: moment().add(7, 'days').format('YYYY-MM-DD')
          })

      }
      
    }
    if(propKey==='pkwChecked')
    // eslint-disable-next-line
    value===true ? null : value=false
  
    if(propKey==='selectedTaskId') this.setState({selectedTask: this.props.tasks[value].hilfen})
   
    this.setState(byPropKey(propKey, value))
  }
  doResetForm = () =>{
    this.setState({
        date: '',
        info: '',
        task: '',
        timeRange: '',
        selectedTask: '',
        selectedTaskId: '',
        pkwChecked: false,
        onTime: false,
        onTimeChecked: false,
        time: '',
        selectedRequester: ''
    })
  }
  
 onSubmit = async (event) => {

  event.preventDefault(event)
    const {date, selectedTask, info, timeRange, pkwChecked, time, onTimeChecked, selectedRequester, selectedTaskId} = this.state

    const isBigger2Days = date >= moment().format('YYYY-MM-DD')
    if(!isBigger2Days) {
      alert('Das Datum darf nicht in der Vergangenheit liegen!')
      return this.dateInputRef.current.focus()
    }
    
    const checkTime = () => {
      if(onTimeChecked===false){
        return 'Nach Vereinbarung'
      } else {
        return time
      }
    }
    const selectedUser = selectedRequester
    //const { history } = this.props
    const author = 'admin'
    const uid = await setImpUser(selectedUser)
    const { ort } = selectedUser
    doAddEvent(timeRange, date, selectedTask, ort, info, uid, pkwChecked, author, checkTime(), selectedTaskId)
   // history.push('EVENTS')
   
    this.doResetForm()
    //this.props.onClickAddEvent(null)
  }

 
 componentDidMount () {
  getImpUsers()
  const { onFetchTasks } = this.props
    fetchTasks.once('value', function(snapshot) {
      onFetchTasks(snapshot.val());
    });
  }

  renderRequesterSelect = () => {
    const options = arraySort(this.props.impUsers, 'name' )|| []
    return (
      <VirtualizedSelect
        options={options}
        style={{margin: '16px 0 16px 0'}}
        onChange={(selectValue) => this.setState({ selectedRequester: selectValue })}
        value={this.state.selectedRequester!==null ? this.state.selectedRequester.extId : null}
        autoFocus
        backspaceRemovesValue
        valueKey='extId' labelKey='name'
        placeholder='....'
    />
    )
  }

  render() {
    const {
        date,
        selectedTask,
        selectedTaskId,
        preTime,
        info,
        timeRange,  
        onTimeChecked,
        time
      } = this.state;
      //form ist invaild if task datea or time (checked) is empty
    const isInvalid = selectedTask === '' || date === '' || (onTimeChecked===true && time==='')
    const {tasks, classes} = this.props
 
    return (
      <DefaultPage headline={{headlineText: 'Hilfebedarf für Hilfesuchenden erstellen'}}>
        <InAppNav links={[{name:'Admin Home', route: routes.ADMINHOME}]}/>
        <Paper className={classes.paper}>
          <form onSubmit={this.onSubmit}>
            <FormControl className={classes.formControl}>
            <FormLabel component="legend">Hilfesuchender</FormLabel>
            {this.renderRequesterSelect()} 

            <FormLabel component="legend">In welchen Zeitraum soll die Hilfe erfolgen?</FormLabel>
            <RadioGroup
              aria-label="Zeitraum"
              name="timeRange"
              className={classes.group}
              value={timeRange}            
              onChange={event => this.handleFormChange('timeRange', event.target.value)}
            >
              <FormControlLabel value="1week" control={<Radio />} label="Innerhalb 1 Woche" />
              <FormControlLabel value="2weeks" control={<Radio />} label="Innerhalb von 2 Wochen" />
              <FormControlLabel value="onDate" control={<Radio />} label="An einem bestimmten Datum" />
            </RadioGroup>
               
            {timeRange==='onDate'
              ? <TextField
                  inputRef={this.dateInputRef}
                  onChange={event => this.handleFormChange('date', event.target.value)}
                  id="date"
                  label="Datum der Hilfeleistung"
                  type="date"
                  defaultValue={preDate}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              : null
            }
            {this.state.onTime===true
              ?<FormControlLabel
                    control={
                      <Checkbox
                        onChange={event => this.handleFormChange('onTimeChecked', event.target.checked)}
                        checked={this.state.onTimeChecked}
                      />
                    }
                  
                    label={this.state.onTimeChecked
                      ? <span style={{color: '#f50057'}}><strong>Uhrzeit erforderlich!</strong></span>
                      : <span>Zu einer bestimmten Uhrzeit?</span>}
                  />
                  :null
            }
            {onTimeChecked===true
              ? <TextField
                  onChange={event => this.handleFormChange('time', event.target.value)}
                  value={this.state.time}
                  id="time"
                  label="Uhrzeit der Hilfeleistung"
                  type="time"
                  defaultValue={preTime}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              : null
            }
            <FormHelperText>Für was benötigen Sie Hilfe?</FormHelperText>
            <Select
              onChange={event => this.handleFormChange('selectedTaskId', event.target.value)}
              value={selectedTaskId}
              input={<Input name="task" id="task-label-placeholder" />}
              displayEmpty
              name="tasks"
              className={classes.selectEmpty}
              style={{maxWidth:'300px', }}
            >
              <MenuItem value="">
                <em>Tätigkeit wählen</em>
              </MenuItem>
              {tasks 
                  ? tasks.map((taskItem, index) => 
                      <MenuItem style={{maxWidth: '320px'}} name='task' key={index} value={index}>
                        {taskItem.hilfen}
                      </MenuItem>
                    )
                  : null
              }
          
            </Select>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={event => this.handleFormChange('pkwChecked', event.target.checked)}
                      checked={this.state.pkwChecked}
                    />
                  }
                
                  label={this.state.pkwChecked
                    ? <span style={{color: '#f50057'}}><strong>Ein Pkw wird benötigt.</strong></span>
                    : <span>Ist ein PKW erforderlich?</span>}
                />
            
              <TextField
                id="multiline-static"
                label="Zusatzinformationen"
                multiline
                rows="5"
                value={info}
                placeholder="Hier können Sie beliebige Zusatzinformationen eingeben"
                className={classes.textField}
                onChange={event => this.handleFormChange('info', event.target.value)}
                margin="normal"
              />
              
              <Button 
                type='submit' 
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={isInvalid}
              >
                Speichern
              </Button>
            </FormControl>
          </form>
          </Paper>
      </DefaultPage>
    )
  }
}

const mapStateToProps = (state) => ({
  userProfile: state.userState.profile,
  tasks: state.tasksState.tasks,
  impUsers: state.adminUserMgm.impUsers
});


const mapDispatchToProps = (dispatch) => ({
    onFetchTasks: (tasks) => dispatch({ type:'FETCH_TASKS', tasks}),
    //onClickAddEvent: (value) => dispatch({ type: 'TOGGLE_ADDEVENT', value })
    
  });

//const authCondition = (authUser) => !!authUser;

AdminAddEvent.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps), 
  withStyles(styles))(AdminAddEvent);


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AddEvent/AdminAddEvent.js